import { render, staticRenderFns } from "./CommunicationItemEmail.vue?vue&type=template&id=405e48c0&scoped=true&"
import script from "./CommunicationItemEmail.vue?vue&type=script&lang=js&"
export * from "./CommunicationItemEmail.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationItemEmail.vue?vue&type=style&index=0&id=405e48c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e48c0",
  null
  
)

export default component.exports